import { CatalogItemViewModel } from '@common/model/catalog/item/view';

interface PrintAddressOptions {
  streetOnly?: boolean;
  enableJSX?: boolean;
}

export const printAddress = (data: CatalogItemViewModel | undefined, options: PrintAddressOptions = {}) => {
  if (!data) {
    return '';
  }

  const address: string = (data.address ?? '').trim();

  if (options.enableJSX) {
    return (
      <>
        <span className="city">{data.city?.translation.name ?? ''}</span>
        {', '}
        <span className="address">{options.streetOnly ? address.split(',')[0] : address}</span>
      </>
    );
  }

  return `${data.city?.translation.name ?? ''}, ${options.streetOnly ? address.split(',')[0] : address}`;
};

export const useAddress = printAddress;
